import Head from 'next/head'
import Page from '../components/Page'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CommonHeadTags from '../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../components/GoogleAnalytics'
import withLocale from '../translations/withLocale'
import useTranslation from '../translations/useTranslation'
import { nonEnglishLocales, localeHreflangs } from '../translations/config'

function Ukulele() {
  const { t } = useTranslation()
  return (
    <>
      <Head>
        <title>{t('title-ukulele')}</title>
        <meta name='description' content={t('description-ukulele')} />
        <meta httpEquiv='content-language' content='en' />
        <link rel='canonical' href='https://guitar-tuner.org/ukulele-tuning' />
        <link
          rel='alternate'
          hrefLang='x-default'
          href='https://guitar-tuner.org/ukulele-tuning'
        />
        <link
          rel='alternate'
          hrefLang='en'
          href='https://guitar-tuner.org/ukulele-tuning'
        />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={localeHreflangs[locale]}
            href={`https://guitar-tuner.org/${locale}/ukulele-tuning`}
          />
        ))}
        <CommonHeadTags
          title={t('title-ukulele')}
          description={t('description-ukulele')}
          url='https://guitar-tuner.org/ukulele-tuning'
        />
        <GoogleAnalyticsHead />
      </Head>

      <Header instrument='ukulele'/>

      <main>
        <Page instrument='ukulele' pageData='ukulele-tuning' />
      </main>

      <Footer />
      <GoogleAnalyticsBody />
    </>
  )
}

export default withLocale(Ukulele)
